import React from 'react'
import Fragment from '../common/fragment'


function FragmentBU(props) {
  return (
    <Fragment pos="uu" {...props}>
      <p>
Pan y circo/fotos y actores/teatro y abejas/soliloquios/el viento del
invierno/sonidos de cosas que no existen/fotógrafos, Pátzcuaro/invasión
extraterrestre (en espera)/Cristo nos habla al oído/¿quiénes tomaron León?/¿quiénes
abandonaron la ciudad como se huye de la muerte?/compañía familiar/teatro
además de fotografía/¿hay alguna diferencia/fotografía además de teatro/¿hay
alguna diferencia?/todo queda en familia: teatro, fotografía y muerte/Cristo nos
dice: “huyan”/¿Quiénes tomaron León entre el polvo y el clamor de las ventiscas?
      </p>
    </Fragment>
  )
}


export default FragmentBU
